import { createSlice } from "@reduxjs/toolkit";

export const generalSlice = createSlice({
    name: 'general',
    initialState: {
        pathForFile: ''
    },
    reducers: {
        setValue: (state, action) => {
            state.value = {
                ...state.value,
                [action.payload.key]: action.payload.value
            }
        }
    }
})

// Action creators are generated for each case reducer function
export const { setValue } = generalSlice.actions

export default generalSlice.reducer